import React, { useState, useEffect } from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MUIDataTable from "mui-datatables";
import Chip from "@mui/material/Chip";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import useSave from "../../Hooks/useSave";
import PrintIcon from "@mui/icons-material/Print";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Order from "./Order";
import CompleteOrder from "./CompleteOrder";
import useProtectView from "../../Hooks/useProtectView";
import DataTable from "../../components/DataTable2/DataTable";

export default function Packing() {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchGraphql, DialogSave } = useSave();
  const canView = useProtectView();

  const [data, setData] = useState([]);

  //create date
  const date = new Date();
  const tomorow = new Date(date);
  const today1 = new Date();
  const tomorow1 = new Date(today1.getTime() + 24 * 60 * 60 * 1000);
  tomorow.setDate(date.getDate() + 1);
  const todayNoTime = new Date(new Date(today1).setHours(0, 0, 0, 0));
  const todayEndofDay = new Date(new Date(today1).setHours(23, 59, 59, 999));

  const [fromDate, setFromDate] = useState(todayNoTime);
  const [toDate, setToDate] = useState(todayEndofDay);

  const [scrollTop, setScrollTop] = useState();

  useEffect(() => {
    fetchGraphql({
      query: `query Orders($options: optionsInput, $orderStatus: [String], $category: String) {
        orders(options: $options, orderStatus: $orderStatus, category: $category) {
          paymentStatus
          packDate
          orderedVia
          orderStatus
          orderId
          orderDate
          lastEditedBy
          deliveryDate
          customerName
          customerId
          createdBy
        }
      }`,
      variables: {
        orderStatus: ["Submited"],
        category: location.pathname.includes("challah") ? "challah" : "cake",
        options: {
          deliveryFromDate: fromDate,
          deliveryToDate: toDate,
        },
      },
    }).then((result) => setData(result.data.orders));

    return () => {};
  }, [location.pathname, fromDate, toDate]);

  const columns = [
    {
      id: "orderId",
      name: "Order Id",
    },
    {
      id: "deliveryDate",
      name: "Delivery Date",
      minWidth: "125px",
      customFilter: (
        <Box>
          <Typography sx={{ marginBottom: "10px" }}>Delivery Date</Typography>

          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="From Date"
              sx={{ marginBottom: "10px" }}
              openTo="day"
              views={["year", "month", "day"]}
              shouldDisableDate={(date) => {
                const today = new Date();
                const todayDate = new Date(date);

                // if (date < today.setDate(today.getDate() - 1))
                //   return true;

                if (date > toDate) return true;

                // if (todayDate.getDay() === 6) return true;
              }}
              value={fromDate || tomorow1}
              onChange={(newValue) => {
                setFromDate(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <Box sx={{ marginTop: "10px" }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                label="To Date"
                openTo="day"
                views={["year", "month", "day"]}
                // shouldDisableDate={(date) => {
                //   const today = new Date();
                //   const todayDate = new Date(date);

                //   if (date < today.setDate(today.getDate() - 1))
                //     return true;

                //   if (todayDate.getDay() === 6) return true;
                // }}
                value={toDate || tomorow1}
                onChange={(newValue) => {
                  setToDate(newValue);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>
        </Box>
      ),
    },
    {
      id: "lastEditedBy",
      name: "Last Edited By",
    },
    {
      id: "customerName",
      name: "Customer name",
      minWidth: "160px",
    },
    {
      id: "orderStatus",
      name: "Status",
      options: {
        customCell: (value) => {
          return (
            <Chip
              label={value}
              color={
                value === "Draft"
                  ? "secondary"
                  : value === "Submited"
                  ? "primary"
                  : "success"
              }
            />
          );
        },
      },
    },
  ];

  const options = {
    editable: false,
    actions: false,
    columnMinWidth: "75px",
    uniqueKey: 2,
    onRowClick: (rowData) => {
      if (location.pathname.includes("challah")) {
        navigate(`/packing/challah/order/${rowData.orderId}`);
      } else {
        navigate(`/packing/cake/order/${rowData.orderId}`);
      }
    },
    onScroll: (e) => {
      setScrollTop(e.target.scrollTop);
    },
    scrollTop,
  };

  return (
    <MiniDrawer sx={{ margin: "150px", height: "100vh" }}>
      {(paper) => {
        return (
          <>
            <DialogSave />
            <Routes>
              <Route
                path="/challah"
                element={
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      height: "100%",
                      // overflow: 'auto'
                    }}
                  >
                    <DataTable
                      title={"Orders"}
                      rows={data}
                      columns={columns}
                      options={options}
                    />
                  </Box>
                }
              />
              <Route
                path="/cake"
                element={
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      height: "100%",
                      // overflow: 'auto'
                    }}
                  >
                    <DataTable
                      title={"Orders"}
                      rows={data}
                      columns={columns}
                      options={options}
                    />
                  </Box>
                }
              />
              <Route
                path="/challah/order/:id"
                element={<Order paper={paper} />}
              />
              <Route
                path="/challah/complete-order/:id"
                element={<CompleteOrder />}
              />
              <Route path="/cake/order/:id" element={<Order paper={paper} />} />
              <Route
                path="/cake/complete-order/:id"
                element={<CompleteOrder />}
              />
            </Routes>
          </>
        );
      }}
    </MiniDrawer>
  );
}
